// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PO_PRODUTO_ST = {
  Pendente: 'PO_PRODUTO_ST1',
  RecebidoParcial: 'PO_PRODUTO_ST2',
  RecebidoTotal: 'PO_PRODUTO_ST3',
  Cancelado: 'PO_PRODUTO_ST4',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PO_PRODUTO_ST1: 1,
    PO_PRODUTO_ST2: 2,
    PO_PRODUTO_ST3: 3,
    PO_PRODUTO_ST4: 4
  }
}
